import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { UPDATE_URL } from '@iwRouter/IwRouter.actions';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { all, fork, put, takeLatest } from 'redux-saga/effects';
import {
    ACCEPT_TRUELAYER_REDIRECT,
    SHOW_CONFIRM_REPAYMENT_STEP,
    SHOW_TRUELAYER_CONFIRMATION,
    TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION
} from '../EarlyRepayment.actions';
import { TRUELAYER_ERROR_ABANDONED_VALUE } from './Truelayer.constants';

export const truelayerSagaWorkers = [
    fork(acceptTruelayerRedirectWorker),
    fork(redirectBackToPaymentConfirmationWorker)
];

function* acceptTruelayerRedirectWorker() {
    yield takeLatest(ACCEPT_TRUELAYER_REDIRECT, function* () {
        const currentLocation = getCurrentLocation();

        const paymentId = getQueryParameter(currentLocation, 'payment_id');
        const error = getQueryParameter(currentLocation, 'error');

        let redirectOutcomeParameter = '';
        if (error && error === TRUELAYER_ERROR_ABANDONED_VALUE) {
            redirectOutcomeParameter = '&redirectOutcome=failure';
        }

        yield put({
            type: UPDATE_URL,
            pathname: '/repayment/truelayer/confirmation/',
            search: `?paymentId=${paymentId}${redirectOutcomeParameter}`
        });
        yield put({
            type: SHOW_TRUELAYER_CONFIRMATION
        });
    });
}

function* redirectBackToPaymentConfirmationWorker() {
    yield takeLatest(
        TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION,
        redirectBackToPaymentConfirmation
    );
}

export function* redirectBackToPaymentConfirmation({
    payload: { amount, accountId }
}) {
    yield all([
        put({
            type: UPDATE_URL,
            pathname: '/repayment/confirm/',
            search: `?amount=${amount}&accountId=${accountId}`
        }),
        put({
            type: SHOW_CONFIRM_REPAYMENT_STEP
        })
    ]);
}
